import type { Prototype } from "../prototype-types";

export const henriquePovedanoPrototypes: Prototype[] = [
  {
    id: "ideas-hub",
    name: "Ideas Hub",
    path: "/hp/ideas-hub",
    description:
      "A page where retailers can see personalized product recommendations via chat-driven discovery. Lives within the Faire site layout with global nav.",
    owner: "Henrique",
    createdAt: "2026-03-04",
    lastUpdated: "2026-03-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8e39b76b85e7288eaeb2f639dd06dd58db9345e452f85ef7f4b6febf88842fcc.png",
    creationTool: "cursor",
  },
];
